module.exports = __webpack_public_path__ + "static/media/messy-laptop-dark.a037d697.png";